module.exports = __webpack_public_path__ + "static/img/dd-partner-01.848c474.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-partner-01.jpg
// module id = knry
// module chunks = 1